import React from "react";
import styled from "styled-components";
import * as colors from "../../assets/_base/colors"

const Icon = styled.i`
    color: ${props => colors[props.type || 'primary']};
    @media(max-width: 700px){
        font-size: .9em
    }
`

export default props => <Icon {...props} />


// WEBPACK FOOTER //
// ./src/_components/Icon/index.jsx